import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionPage.module.css";
import axios from 'axios';
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { loginApi } from '../http/http';
import { FaCopyright } from 'react-icons/fa6';

const LoginPage = () => {
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(true);
    const [subscribeLoading, setSubscribeLoading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            if (msisdn?.trim().length > 0) {

                setSubscribeLoading(true);
                let msisdn2 = msisdn;

                if (msisdn2.startsWith("0")) {
                    msisdn2 = msisdn2.substring(1);
                }

                if (!msisdn2.startsWith("278")) {
                    msisdn2 = "278" + msisdn2;
                }

                const response = await axios.post(loginApi, {
                    msisdn: msisdn2,
                    ext_ref: extRef,
                });

                console.log(response, 'response...');

                setSubscribeLoading(false);
                Cookies.set('msisdn', msisdn2, { expires: 1 });
                navigate("/home");
            }
            else {
                toast.error("Please Enter the Number!");
                return;
            }

        } catch (error) {
            console.log(error, 'error---');
            setSubscribeLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || "Something Went Wrong!");
        }
    }

    return (
        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>
                </nav>
            </header>


            <section className={classes.section_landing_page}>
                <div className={classes.grid_container}>
                    <div className={classes.grid_section_one}>
                        <form className={classes.form}>

                            <div className={classes.landingPageBanner}>
                                <img src="assets/images/banner.png" alt="Banner" className={classes.banner} />
                            </div>

                            <input type='number' placeholder='Enter your Number' value={msisdn} onChange={(e) => setMsisdn(e.target.value)}
                                className={classes.input}
                            />
                            <button className={classes.login_btn} id="subscribe_btn" onClick={handleLogin}
                                disabled={subscribeLoading}
                            >
                                {subscribeLoading ? "Loading..." : (
                                    <>
                                        Login 
                                    </>

                                )}
                            </button>

                            <div className={classes.grid_or_container}>
                                <span className={classes.grid_item}></span>
                                <span className={classes.or}>Or</span>
                                <span className={classes.grid_item}></span>
                            </div>

                            <button className={classes.loginLink} onClick={() => navigate(`/?ext_id=${extRef}`)}>
                                New User, Subscibe Now
                            </button>

                        </form>

                    </div>
                    <div className={classes.grid_section_two}>
                        <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />


                        <p className={classes.portal_description}>
                            Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                        </p>

                        <div className={classes.grid_sub_container}>
                            <div className={classes.kids_image_container}>
                                <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                            </div>
                            <div className={classes.kids_info}>
                                <p className={classes.kids_info_text_one}>Made For</p>
                                <p className={classes.kids_info_text_two}>- Kids</p>
                            </div>
                        </div>
                    </div>

                </div>
                <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>

                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                Rainboo Softmate Pvt Ltd
                            </p>
                        </div>
                    </div>


                </div>
            </section>

        </main>
    )
}

export default LoginPage